module.exports = __webpack_public_path__ + "img/ALSH_SEJOUR_NOEL.51d98d2e.svg";